// extracted by mini-css-extract-plugin
export default {"label":"_59tE82fs9EKQjrbu4EtJlw","verticalAlignMiddle":"_7gOxJW4pMabKedVwJG53n3","labelText":"_1nrmrUpSw63dfqGIuABuP8","icon":"BKg60C42bhKDlRbLOcjgr"};